import React, { useEffect, useRef, useState } from "react"
import { useInView } from "react-intersection-observer"
import { Box, Container, Flex, Image, Text } from "@theme-ui/components"
import { InboundLink } from "../link"
import { getPagePath } from "../../utils/path"
import RichContentStructuredText from "../richContentStructuredText"
import { BsChevronLeft, BsChevronRight } from "react-icons/bs"
import { motion, AnimatePresence } from "framer-motion"
import MuxPlayer from "@mux/mux-player-react"

const PageCarousel = ({ title, pages }) => {
  // console.log(pages)
  const [activeIndex, setActiveIndex] = useState(0)
  const playerRef = useRef(true)
  const [ref, inView] = useInView({
    threshold: 0.2,
  })
  // useEffect(() => {
  //   if (inView === true) {
  //     playerRef.current.play()
  //   }
  // }, [inView])

  return (
    <Box
      sx={{
        backgroundColor: "primary",
        position: "relative",
        height: ["60vh"],
      }}
    >
      {pages.map((page, index) => (
        <AnimatePresence>
          {activeIndex === index && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 1 }}
            >
              <Box
                sx={{
                  display: "flex",
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  top: 0,
                  left: 0,
                }}
              >
                <Container
                  sx={{
                    display: "flex",
                    height: ["100%"],
                    maxWidth: ["920px"],
                    zIndex: 1,
                    position: "relative",
                    justifyContent: "center",
                  }}
                >
                  <InboundLink
                    to={getPagePath(page, page.locale)}
                    style={{
                      display: "flex",
                      textDecoration: "none",
                    }}
                  >
                    <Flex
                      sx={{
                        width: ["100%"],
                        justifyContent: "center",
                        flexDirection: "column",
                        textAlign: "center",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        className="icon"
                        sx={{
                          mb: [5],
                          display: "block",
                          img: { display: "block" },
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "light",
                          borderRadius: "15px",
                          overflow: "hidden",
                          border: "1px solid",
                          borderColor: "#ffffff",
                          width: ["80px"],
                          img: {
                            border: "1px solid",
                            borderColor: "#ffffff",
                          },
                        }}
                      >
                        <Image src={page.icon.url} />
                      </Box>
                      <Text
                        as="h2"
                        variant="h4"
                        sx={{
                          mb: [2],
                          mt: [0],
                          fontSize: [5, 7, 8],
                          color: "light",
                          fontWeight: "700",
                          textTransform: "uppercase",
                        }}
                      >
                        {page.title}
                      </Text>
                      <Box
                        sx={{
                          py: [2, 4],
                          p: {
                            fontSize: ["15px", 1, 2],
                            color: "light",
                            fontWeight: "300",
                          },
                          h2: {
                            fontWeight: [400],
                            fontSize: [2, 2, 2, 5],
                            color: "light",
                          },
                        }}
                      >
                        <RichContentStructuredText
                          text={page.shortDescription}
                        />
                      </Box>
                    </Flex>
                  </InboundLink>
                </Container>
                <Box
                  sx={{
                    position: "absolute",
                    width: ["90%"],
                    top: ["10%", "10%", "46%"],
                    display: "flex",
                    justifyContent: "space-between",
                    zIndex: 1,
                    mx: ["5%"],
                  }}
                >
                  <Flex
                    onClick={() => {
                      setActiveIndex(
                        activeIndex === 0 ? pages.length - 1 : activeIndex - 1
                      )
                    }}
                    sx={{
                      p: [2],
                      borderRadius: "full",
                      border: "1px solid",
                      width: "48px",
                      height: "48px",
                      borderColor: "light",
                      color: "light",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      transition: ".3s all ease",
                      "&:hover": {
                        backgroundColor: "light",
                        color: "primary",
                      },
                    }}
                  >
                    <BsChevronLeft size={24} />
                  </Flex>
                  <Flex
                    onClick={() => {
                      setActiveIndex(
                        activeIndex + 1 >= pages.length ? 0 : activeIndex + 1
                      )
                    }}
                    sx={{
                      p: [2],
                      borderRadius: "full",
                      border: "1px solid",
                      width: "48px",
                      height: "48px",
                      borderColor: "light",
                      color: "light",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      transition: ".3s all ease",
                      "&:hover": {
                        backgroundColor: "light",
                        color: "primary",
                      },
                    }}
                  >
                    <BsChevronRight size={24} />
                  </Flex>
                </Box>
                <Box
                  ref={ref}
                  sx={{
                    height: "100%",
                    width: "100%",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    backgroundColor: "primary",
                    overflow: "hidden",
                    video: {
                      objectFit: "cover",
                      objectPosition: "center",
                    },
                    "mux-player": {
                      "--controls": "none",
                    },
                  }}
                >
                  {/* <MuxPlayer
                    streamType="on-demand"
                    id={page.heroImage.video.muxPlaybackId}
                    playbackId={page.heroImage.video.muxPlaybackId}
                    playsInline
                    secondaryColor="#00a889"
                    primaryColor="#ffffff"
                    muted
                    loop
                    poster={false}
                    ref={playerRef}
                  /> */}
                  <video
                    title={"background-video"}
                    id=""
                    class=""
                    loop
                    autoPlay
                    muted
                    playsinline="playsinline"
                  >
                    <source
                      src={page.heroImage.url}
                      type={page.heroImage.mimeType}
                    />
                  </video>
                </Box>
              </Box>
            </motion.div>
          )}
        </AnimatePresence>
      ))}
    </Box>
  )
}

export default PageCarousel
